import styled from 'styled-components';

export const PromotionOuterContainer = styled.div`
  align-items: center;
  text-align: center;
  margin: 0 auto;
  min-height: 100%;
  background-color: var(--gallery);
  padding: 30px 0;
`;

export const PromotionInnerContainer = styled.div`
  margin: 0 auto;
  align-items: center;
  min-height: 100%;
  max-width: 1300px; 
  background-color: var(--white);
  padding: 50px 25px;
  border-radius: 6px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.16);
  min-width: 280px;

  @media (max-width: 1300px) {
    margin: 0 24px;
  }
`;

export const PromotionTextContainer = styled.div`
  padding-bottom: 50px;

  @media (max-width: 640px) {
    padding-bottom: 0px;
  }
`;

export const PromotionButtonContainer = styled.div`
  padding-top: 50px;
`;

export const PromotionDesktopImageContainer = styled.div`
  align-items: center;
  text-align:center;
  margin: 0 auto;

  @media (max-width: 640px) {
    display: none;
  }
`;

export const PromotionMobileImageContainer = styled.div`
  align-items: center;
  text-align:center;
  height: 100%;
  width: 100%;

  @media (min-width: 641px) {
    display: none;
  }
`;
